import { ReactNode } from 'react';

import { TypographyProps } from '@scaleaq/scaleui';

import { ElementWrapper } from './ElementWrapper';

type DataRowLabelProps = {
  type: TypographyProps['type'];
  value?: string | ReactNode;
};

export const DataRowLabel = ({ type, value }: DataRowLabelProps) => {
  if (value === undefined) {
    return null;
  }

  return <ElementWrapper value={value} type={type} />;
};
